(function () {
  var overlay = document.getElementById('CartDrawerOverlay');
  var drawer = document.getElementById('CartDrawer');
  var linesEl = document.querySelector('[data-cart-lines]');
  var descEl = document.querySelector('[data-cart-drawer-desc]');
  var footerEl = document.querySelector('[data-cart-footer]');
  var totalEl = document.querySelector('[data-cart-total]');
  var triggers = document.querySelectorAll('[data-cart-open]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  function t() {
    return window.CosmicCartI18n || {};
  }

  function esc(s) {
    if (s == null || s === '') return '';
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getLineProp(item, key) {
    if (!item || !item.properties) return null;
    var p = item.properties;
    if (Array.isArray(p)) {
      for (var i = 0; i < p.length; i++) {
        if (p[i] && p[i].name === key) return p[i].value;
      }
      return null;
    }
    return p[key] != null ? p[key] : null;
  }

  function setOpen(open) {
    if (!drawer || !overlay) return;
    drawer.classList.toggle('is-open', open);
    overlay.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    overlay.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  function updateCount(itemCount) {
    countEls.forEach(function (el) {
      el.textContent = itemCount > 0 ? String(itemCount) : '';
      el.style.display = itemCount > 0 ? 'inline-flex' : 'none';
    });
  }

  function formatItemsInCart(n) {
    var tpl = t().itemsInCart || '__C__ item(s) in the cart';
    return String(tpl).replace('__C__', String(n));
  }

  function formatMoneyCents(cents, currencyCode) {
    var code = currencyCode || 'EUR';
    var v = (cents || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: code }).format(v);
    } catch (e) {
      return v.toFixed(2) + ' ' + code;
    }
  }

  function purchaseLabel(item) {
    var spa = item.selling_plan_allocation;
    if (spa && spa.selling_plan && spa.selling_plan.name) {
      return { type: 'plan', text: String(spa.selling_plan.name) };
    }
    if (getLineProp(item, 'Subscription') === 'Yes' || getLineProp(item, 'Subscription') === 'yes') {
      return { type: 'sub', text: t().subscription || 'Subscription' };
    }
    return { type: 'one', text: t().oneTime || 'One-time' };
  }

  function renderCart(cart) {
    if (!linesEl || !descEl || !footerEl || !totalEl) return;
    var count = cart.item_count || 0;
    var currency = cart.currency || (cart.items && cart.items[0] && cart.items[0].currency) || 'EUR';
    updateCount(count);

    if (count === 0) {
      descEl.textContent = t().empty != null ? t().empty : 'Your cart is empty';
      footerEl.hidden = true;
      var hint = t().emptyHint != null ? t().emptyHint : 'Add products from the shop or offer page.';
      linesEl.innerHTML =
        '<p class="cart-drawer__empty-hint" style="color:rgba(255,255,255,0.5);text-align:center;padding:2rem 0;">' +
        esc(hint) +
        '</p>';
      return;
    }

    descEl.textContent = formatItemsInCart(count);
    footerEl.hidden = false;
    totalEl.textContent = formatMoneyCents(cart.total_price, currency);

    linesEl.innerHTML = cart.items
      .map(function (item) {
        var pl = purchaseLabel(item);
        var planLine;
        if (pl.type === 'one') {
          planLine = '<p class="cart-line__plan cart-line__plan--once">' + esc(pl.text) + '</p>';
        } else {
          var subClass = pl.type === 'plan' || pl.type === 'sub' ? ' cart-line__plan--sub' : '';
          planLine = '<p class="cart-line__plan' + subClass + '">' + esc(pl.text) + '</p>';
        }

        var img = item.image
          ? '<img class="cart-line__img" src="' + esc(item.image) + '" alt="">'
          : '<div class="cart-line__img"></div>';
        var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? String(item.variant_title) : '';
        var vLabel = t().lineVariantLabel || 'Option';
        var variantBlock =
          variantTitle === ''
            ? ''
            : '<p class="cart-line__meta"><span class="cart-line__meta-lbl">' +
              esc(vLabel) +
              '</span> · ' +
              esc(variantTitle) +
              '</p>';

        return (
          '<div class="cart-line" data-key="' +
          esc(item.key) +
          '">' +
          img +
          '<div style="flex:1;min-width:0">' +
          '<p class="cart-line__title">' +
          esc(item.product_title) +
          '</p>' +
          planLine +
          variantBlock +
          '<div class="cart-line__qty-row">' +
          '<span class="cart-line__qty-lbl visually-hidden">' +
          esc(t().qty || 'Quantity') +
          '</span>' +
          '<div style="display:flex;align-items:center;gap:0.5rem;margin-top:0.5rem">' +
          '<button type="button" class="cart-line__qty-btn" data-qty-minus="' +
          esc(item.key) +
          '" aria-label="−" style="width:28px;height:28px;border-radius:6px;border:none;cursor:pointer">−</button>' +
          '<span class="cart-line__qty" style="color:#fff;font-size:0.875rem">' +
          item.quantity +
          '</span>' +
          '<button type="button" class="cart-line__qty-btn" data-qty-plus="' +
          esc(item.key) +
          '" aria-label="+" style="width:28px;height:28px;border-radius:6px;border:none;cursor:pointer">+</button>' +
          '</div></div></div></div>'
        );
      })
      .join('');

    linesEl.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.getAttribute('data-qty-minus'), -1);
      });
    });
    linesEl.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeLine(btn.getAttribute('data-qty-plus'), 1);
      });
    });
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function refresh() {
    return fetchCart().then(renderCart);
  }

  function getLineRowByKey(key) {
    if (!linesEl) return null;
    var rows = linesEl.querySelectorAll('.cart-line');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-key') === key) {
        return rows[i];
      }
    }
    return null;
  }

  function changeLine(key, delta) {
    var row = getLineRowByKey(key);
    var qEl = row && row.querySelector('.cart-line__qty');
    var cur = qEl ? parseInt(String(qEl.textContent).trim(), 10) : NaN;
    if (!row || isNaN(cur)) {
      return refresh();
    }
    var qty = Math.max(0, cur + delta);
    if (linesEl) {
      linesEl.setAttribute('data-cart-updating', 'true');
    }
    if (row) {
      row.setAttribute('data-line-busy', 'true');
    }
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then(function (r) {
        return r
          .json()
          .then(function (j) {
            return { res: r, j: j };
          })
          .catch(function () {
            return { res: r, j: null };
          });
      })
      .then(function () {
        return fetchCart().then(renderCart);
      })
      .catch(function () {
        return fetchCart().then(renderCart);
      })
      .finally(function () {
        if (linesEl) {
          linesEl.removeAttribute('data-cart-updating');
        }
        if (row) {
          row.removeAttribute('data-line-busy');
        }
      });
  }

  triggers.forEach(function (tr) {
    tr.addEventListener('click', function (e) {
      e.preventDefault();
      refresh().then(function () {
        setOpen(true);
      });
    });
  });

  if (overlay) {
    overlay.addEventListener('click', function () {
      setOpen(false);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  document.addEventListener('cart:refresh', function (e) {
    var d = (e && e.detail) || {};
    refresh().then(function () {
      if (d.silent) return;
      setOpen(true);
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart().then(renderCart);
  });
})();
